import { Components, Theme } from "@mui/material";
import * as ComponentOverrides from "./Overrides";

export const COMPONENT_OVERRIDES: Components<Theme> = {
  ...ComponentOverrides,
};
